import { httpRequest } from "../../http";

export class CommandSetBrandAssetTag {
    async run(organizationId: string, brandId: string, assetId: number, tag: string | null) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/assets/${assetId}/tag`;
        return await httpRequest<any>(url, { method: "POST", body: { tag } });
    }
}
